import { FunctionComponent, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Text from '@media-ui/core/src/components/Text';
import * as T from './FormField.types';
import * as s from './FormField.css';
const FormField: FunctionComponent<T.FormFieldProps> = ({ name, label, children, required, overrideClassname, withoutRegister, pattern, validate, }) => {
    const { register, getValues, setValue, errors } = useFormContext();
    const valueFromForm = getValues(name);
    useEffect(() => {
        if (!withoutRegister) {
            register({ name, type: 'custom' }, {
                required,
                pattern,
                validate,
            });
            valueFromForm && setValue(name, valueFromForm);
        }
    }, []);
    return (<div className={overrideClassname || s.root}>
      {label && <Text tag="div">{label}</Text>}
      {children}
      {errors[name] && (<Text tag="div" className={s.error}>
          {errors[name].message}
        </Text>)}
    </div>);
};
export default FormField;
